import React from 'react'
import { withRouter } from 'react-router-dom';
import ReactGA from 'react-ga4';

function RouteChangeTracker({ history }) {
    history.listen((location, action) => {
        ReactGA.set({ page: location.pathname + location.search });
        ReactGA.send({ hitType: "pageview", pathname: location.pathname + location.search });
    });

    return (
        <></>
    )
}

export default withRouter(RouteChangeTracker);